// extracted by mini-css-extract-plugin
export default {"wrapper":"HeaderBackButton_wrapper__DGvLB","navigationBack":"HeaderBackButton_navigationBack__P3sGn","textWrapper":"HeaderBackButton_textWrapper__mioas"};